import React, { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Axios from '../../axios/axios';
import { Header } from '../../components/SpearParts/Layouts/Header';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link } from 'react-router-dom';


function SupplierLogin() {
    const [email, setEmail] = useState('');
      const [password, setPassword] = useState('');
      const [error, setError] = useState('');
      const navigate = useNavigate();
      const location = useLocation();
      const [searchParams] = useSearchParams();
      const redirect = searchParams.get('redirect') || '/';
      const [showPassword, setShowPassword] = useState(false);


      const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await Axios.post('supplier/login', { email, password });
            const supplierInfo = {
          token: response.data.token,
          username: response.data.username,
          supplierId: response.data.supplierId,
          productCategory: response.data.productCategory || response.data.category || null,
        };
        sessionStorage.setItem('supplierInfo', JSON.stringify(supplierInfo));
        console.log(supplierInfo);
        navigate('/SupplierDashboard');
      window.location.reload();
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    }
  };
  return (
    <div>
      <Header />
      <section id="login">
        <div className="container" style={{ marginTop: '150px' }}>
          <div className="col-md-6 offset-md-3">
            <h3>Supplier Login</h3>
            <p>
              From its medieval origins to the digital era, learn everything
              there is to know about the ubiquitous lorem ipsum passage.
            </p>

            <div className="col-md-10 offset-md-1 login_form">
              {error && (
                <p className="error" style={{ color: 'red' }}>
                  {error}
                </p>
              )}
              

              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label htmlFor="inputEmail">Email*</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group password_form">
                  <label htmlFor="inputPassword">Password*</label>
                  <div className="passwordtext" style={{ position: 'relative' }}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="pass_textarea form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                      }}
                    >
                      {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                    </span>
                  </div>
                  <a href="/forgot" className="forgotPassword">
                    Forgot password
                  </a>
                </div>

                <div className="my-5">
                  <button type="submit" className="loginButton login_btn">
                    Login
                  </button>
                </div>
              </form>
              
              {/* Add this link for customer login redirect */}
              <div style={{ marginTop: '10px' }}>
                <Link to="/login" className="customer-login-link">
                  Login as Customer 
                </Link>
              </div>
              
              <p className="dontHaveAccount">Don't have an account?</p>
              <div>
                <Link to="/signup-supplier" className="signupButton">
                  Signup
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SupplierLogin
